import React, { useEffect, useState, useCallback } from 'react'

// Deps
//import animateScrollTo from 'animated-scroll-to';
import { connect } from 'react-redux'

// Functions
// import UID from 'functions/uid'

const mapStateToProps = state => {
	return { mobileState: state.site.mobile };
};

const usePages = (pagination) => {
	let list = false;
	if(pagination) {
		list = [];
		for(let k = 0; k < pagination.last_page; k++) {
			list.push(k+1);
		}
	}

	return list;
}

const RawTable = (props) => {
	const [cachedChildren, setCachedChildren] = useState(false);
	const [mobileState, setMobileState] = useState(props.compact ? true : props.mobileState);
	const pages = usePages(props.pagination);

	const modifyChildren = useCallback((children, mobile) => {
		return React.Children.map(children, child => {
			if (child !== null) {
				if (!child.props) {
					return child
				}
				else {
					let type = child.props ? child.props.tableChildComponentType : false;
					//child.type ? child.type.name : false;
					let mobileProps = false;

					if (type === 'TR' || type === 'TD') {
						mobileProps = {mobileState: mobile};
						// let clone = React.cloneElement(child, {mobileState: mobileState});
						// return clone;
					}
					if (child.props.children) {
						return React.cloneElement(child, {
							children: modifyChildren(child.props.children, mobile),
							...(mobileProps ? mobileProps : {}),
						});
					}
					else if(mobileProps) {
						let clone = React.cloneElement(child, mobileProps);
						return clone;
					}
					else {
						return child;
					}
				}
			}
		})
	}, []);

	useEffect(() => {
		setMobileState(props.compact ? true : props.mobileState);
	}, [props.mobileState, props.compact]);

	useEffect(() => {
		setCachedChildren(modifyChildren(props.children, mobileState));
	}, [props.children, mobileState, modifyChildren])

	return (
		<div className={'table-container ' + (props.className ? props.className : '') + (mobileState ? ' mobile-state' : '') + (props.paginating ? ' paginating' : '') }>
			{props.children.length ?
				<React.Fragment>
					<table>
						{!mobileState && props.heading &&
							<thead>
								<tr className="table-heading">
									{props.heading}
								</tr>
							</thead>
						}
						<tbody>
							{cachedChildren}
						</tbody>
					</table>
					{pages &&
						<div className={'table-pagination' + (props.paginating ? ' loading' : '')}>
							<div className="pagination-content">
								<button
									type="button"
									className="pagination-btn prev"
									disabled={props.paginating || props.pagination.current_page <= 1}
									onClick={() => { props.onPaginate(props.pagination.current_page -1) }}>
									<i className="icon-angle-left"></i>
								</button>
								<label
									className="pagination-display">
									{props.pagination.current_page} / {props.pagination.last_page}
									<select
										disabled={props.paginating}
										className="pagination-list"
										defaultValue={props.pagination.current_page}
										onChange={(e) => { props.onPaginate(parseInt(e.target.value)); }}>
										{pages.map((page) => (
											<option
												key={page}
												value={page}>
												{page}
											</option>
										))}
									</select>
								</label>
								<button
									type="button"
									className="pagination-btn next"
									disabled={props.paginating || props.pagination.current_page >= props.pagination.last_page}
									onClick={() => { props.onPaginate(props.pagination.current_page + 1) }}>
									<i className="icon-angle-right"></i>
								</button>

							</div>
						</div>
					}
				</React.Fragment>
				:
				<div className="alert center warning table-emptymessage"><div className="alert-content">{props.emptyMessage}</div></div>

			}
		</div>
	)
}

const Table = connect(mapStateToProps)(RawTable);

Table.defaultProps = {
	emptyMessage: 'Sonuç bulunamadı',
	compact: false,
	paginating: false,
}

const TR = ({hideMobile, mobileState, hideWeb, children, mobileTitle, tableChildComponentType, ...props}) => {
	if(!(hideMobile && mobileState) && !(hideWeb && !mobileState)){
		return (
			<tr {...props}>
				{(mobileState && mobileTitle) && 
					<td className="row-mobiletitle">{mobileTitle}</td>
				}
				{children}
			</tr>
		)
	}
	else { return false; }
}

TR.defaultProps = {
	tableChildComponentType: 'TR'
}

// const TR = connect(mapStateToProps)(RawTR);

const TD = ({mobileState, children, hideWeb, hideMobile, mobileTitle, tableChildComponentType, ...props}) => {
	if(!(hideMobile && mobileState) && !(hideWeb && !mobileState)){
		return (
			<td {...props}>
				{(mobileState && mobileTitle) &&
					<strong className="col-mobiletitle">{mobileTitle}</strong>
				}
				{children}
			</td>
		)
	}
	else { return false; }
}

TD.defaultProps = {
	tableChildComponentType: 'TD'
}

// const TD = connect(mapStateToProps)(RawTD);

export {
	Table,
	TR,
	TD,
}
